// extracted by mini-css-extract-plugin
module.exports = {"logo":"AppBarComponent_logo__8_qMM","menuSelected":"AppBarComponent_menuSelected__8z7uy"};